// extracted by mini-css-extract-plugin
export var divider = "_yu-0";